import { atom } from "nanostores";
import { requestGet } from "../utils/request.ts";

export type OSSInfo = {
    id: number;
    oss_id: number;
    oss_name: string;
    oss_bucket: string;
    oss_endpoint: string;
    paid: boolean;
    vip_expire?: number;
};

export type GetOSSListResponse = {
    osses: OSSInfo[];
};

/* ==== Stores ==== */
export const $ossList = atom<OSSInfo[]>([]);
export const $ossListLoaded = atom(false);

/* ==== Actions ==== */
export const updateOSSInfo = async () => {
    try {
        const resp = await requestGet<GetOSSListResponse>("/v2/oss");
        $ossList.set(resp.osses ?? []);
        $ossListLoaded.set(true);
    } catch (e) {
        console.error(e);
        throw e;
    }
};
